/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AlignCenterIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Align Center',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M29 20H18v-4h7a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-7V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V6H9a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h7v4H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h11v5.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V30h11a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z"
    />
  </svg>`;
};
